export default __webpack_public_path__ + "static/media/fuelActiveIcon.43454dc6.svg";